import { CountyTaxTable } from 'designsystem/calculators/CountyTaxTable';

export const CountyTaxTableFeature = () => {
	return (
		<CountyTaxTable
			onTagRemoved={(v: string) => console.log(`tag removed: ${v}`)}
			onTagSelected={(v: string) => console.log(`tag added: ${v}`)}
			tableDropdownHeaders={['Kommune', 'År']}
			yearStart={2007}
			yearEnd={2025}
			feedback_search="Vælg et årstal eller en kommune for at få vist data"
			tableHeaders={[
				'Kommunenavn',
				'År',
				'Kommuneskat',
				'Kirkeskat',
				'Sundhedsbidrag',
				'Bundskat',
				'I alt',
				'Skatteloftsnedslag<span aria-hidden="true">*</span>',
				'Grundskyldspromille<br/>(Kommune)',
			]}
		/>
	);
};
